import type { ThemeConfiguration } from "Infrastructure/Theme/Atom/types";
import { Language } from "Infrastructure/Translation/types";
import { atomWithStorage } from "jotai/utils";

export const themeConfigurationDefaultState: ThemeConfiguration = {
	activeDir: "ltr",
	activeMode: "dark",
	activeTheme: "BLUE_THEME",
	SidebarWidth: 240,
	MiniSidebarWidth: 80,
	TopbarHeight: 70,
	isCollapse: true,
	isSidebarHover: false,
	isMobileSidebar: false,
	isHorizontal: false,
	isLanguage: Language.gb,
	isCardShadow: true,
	borderRadius: 7,
};

export const themeAtom = atomWithStorage<ThemeConfiguration>(
	"theme",
	themeConfigurationDefaultState,
);
